'use client';

import { c as _c } from "react/compiler-runtime";
import { UISwitcher } from '@/comps/ui/buttons/UISwitcher/UISwitcher';
import type { SegmentKind } from '@/domains/pages/shared/segment-kind';
import { cn } from '@/utils/shad';
export type SegmentScopeView = 'all' | SegmentKind;
const VIEW_OPTIONS: {
  value: SegmentScopeView;
  label: string;
}[] = [{
  value: 'all',
  label: 'All'
}, {
  value: 'team',
  label: 'Team'
}, {
  value: 'market',
  label: 'Market'
}, {
  value: 'tenure',
  label: 'Tenure'
}];
export const SEGMENT_ONLY_SCOPE_OPTIONS: {
  value: SegmentScopeView;
  label: string;
}[] = [{
  value: 'team',
  label: 'Team'
}, {
  value: 'market',
  label: 'Market'
}, {
  value: 'tenure',
  label: 'Tenure'
}];
type SegmentScopeTabsProps = {
  value: SegmentScopeView;
  onValueChange: (view: SegmentScopeView) => void;
  options?: {
    value: SegmentScopeView;
    label: string;
  }[];
  className?: string;
};
export function SegmentScopeTabs(t0) {
  const $ = _c(9);
  const {
    value,
    onValueChange,
    options: t1,
    className
  } = t0;
  const options = t1 === undefined ? VIEW_OPTIONS : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("max-w-max shrink-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== options) {
    t3 = options.map(_temp);
    $[2] = options;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onValueChange || $[5] !== t2 || $[6] !== t3 || $[7] !== value) {
    t4 = <UISwitcher className={t2} value={value} onChange={onValueChange} items={t3} />;
    $[4] = onValueChange;
    $[5] = t2;
    $[6] = t3;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(option) {
  return {
    value: option.value,
    label: option.label
  };
}